import { levelOneNavigationSelectors as selector } from "../Selectors/index";

export const levelOneNavigationReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_LEVEL_ONE_ROLE_SUCCESS:
      return payload;

    default:
      return state;
  }
};